import React from "react";
import RoomsSec1 from "./Rooms/RoomsSec1";
import RoomsSec2 from "./Rooms/RoomsSec2";
import Experience from "./About/Experience";

const Rooms = () => {
  return (
    <div>
      <RoomsSec1 />
      <RoomsSec2 />
      <Experience />
    </div>
  );
};

export default Rooms;
